import React from 'react';
import { CallType } from './commonUtil';

export const CallTypeComponent = (props) => {
  const { active, title, content, callType } = props;
  let starterClass = 'icon-pc-blue';
  let callingClass = 'icon-calling-blue';
  let userClass = 'icon-user-blue';
  if (active) {
    if (callType == CallType.NET) {
      starterClass = 'icon-pc-blue';
      callingClass = 'icon-calling-blue';
      userClass = 'icon-user-blue';
    } else {
      starterClass = 'icon-phone-blue';
      callingClass = 'icon-calling-blue';
      userClass = 'icon-user-blue';
    }
  } else {
    if (callType == CallType.NET) {
      starterClass = 'icon-pc-gray';
      callingClass = 'icon-calling-gray';
      userClass = 'icon-user-gray';
    } else {
      starterClass = 'icon-phone-gray';
      callingClass = 'icon-calling-gray';
      userClass = 'icon-user-gray';
    }
  }
  return (
    <div className={active ? 'lead-calling active' : 'lead-calling'} onClick={() => props.selectType(callType)}>
      <div className={active ? 'call-title active' : 'call-title'}>
        {active && <div className="icon-net-check" />}
        <div className="call-type">{title}</div>
        {callType == CallType.NET && <div className="icon-net-recommend" />}
      </div>
      <div className="call-content">
        <div className="call-panel">
          <div className={starterClass}></div>
          <div className={callingClass}></div>
          <div className={userClass}></div>
        </div>
        {props.renderContent()}
      </div>
    </div>);
};
